<template>
	<div class="package-add-more-page">

		<!-- ===== 面包屑 + 返回 ===== -->
		<div class="breadcrumb-bar animate__animated animate__fadeIn" @click="back()">
			<div class="bc-left">
				<span class="bc-label">当前位置：</span>
				<span class="bc-item">我的包裹</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30868_5084/24.svg')"></el-image>
				<span class="bc-item">添加包裹</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30868_5084/25.svg')"></el-image>
				<span class="bc-item bc-active">批量预报</span>
			</div>
			<div class="bc-right">
				<span class="bc-back-text">返回</span>
				<el-image class="bc-back-icon" :src="require('@/static/CodeBuddyAssets/30868_5084/26.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 表单卡片 ===== -->
		<div class="form-card animate__animated  ">
			<!-- 基本信息 -->
			<div class="section-header">
				<el-image class="sec-icon" :src="require('@/static/CodeBuddyAssets/30868_5084/29.svg')"></el-image>
				<h3 class="sec-title">基本信息</h3>
			</div>
			
			<div class="form-row">
				<div class="form-col-left">
					<div class="form-item">
						<label class="form-label">入库仓库</label>
						<div class="form-input-wrap">
							<el-select v-model="warehouse" placeholder="请选择" class="form-select">
								<el-option v-for="item in warehouseOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="form-col-right">
					<div class="form-item">
						<label class="form-label">寄往国家</label>
						<div class="form-input-wrap country-field">
							<div class="country-trigger" @click="toggleCountryPanel">
								<span v-if="selectedCountryName" class="country-trigger-value">{{selectedCountryName}}</span>
								<span v-else class="country-trigger-placeholder">请选择</span>
								<i class="el-icon-arrow-down country-trigger-arrow" :class="{ 'arrow-up': showCountryPanel }"></i>
							</div>
							<!-- 国家弹出选择面板：搜索框 + 字母索引 -->
							<div class="country-panel" v-show="showCountryPanel" @click.stop>
								<div class="country-search">
									<el-input v-model="searchKeyword" placeholder="搜索国家/地区" class="country-search-input" clearable>
										<i slot="prefix" class="el-icon-search"></i>
									</el-input>
								</div>
								<div class="country-body">
									<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
										<template v-for="group in filteredCountries">
											<div class="country-group" :key="group.letter" :data-letter="group.letter">
												<div class="country-group-title">{{group.letter}}</div>
												<div class="country-item" :class="{ active: country === item.value }" v-for="item in group.items" :key="item.value" @click="selectCountry(item)">
													<span class="country-name">{{item.label}}</span>
												</div>
											</div>
										</template>
										<div v-if="filteredCountries.length === 0" class="country-empty">暂无匹配国家</div>
									</div>
									<div class="country-index">
										<span v-for="letter in availableLetters" :key="letter" class="country-index-item" :class="{ active: activeLetter === letter }" @click="scrollToLetter(letter)">{{letter}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="form-item form-item--block">
				<label class="form-label form-label--bold">批量添加快递单号</label>
				<span class="form-hint">请依次输入快递单号，确保每行一个快递单号*</span>
				<div class="form-textarea">
					<el-input
						type="textarea"
						:rows="5"
						v-model="expressNumbers"
						placeholder="请输入快递单号">
					</el-input>
				</div>
			</div>
			
			<div class="form-row">
				<div class="form-col-left">
					<div class="form-item form-item--row">
						<div class="form-col-inner">
							<label class="form-label">唛头</label>
							<div class="form-input-wrap">
								<el-select v-model="mark" placeholder="请选择" class="form-select">
									<el-option v-for="item in maitouOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
							<!-- <div class="form-input-wrap form-input-wrap--short">
								<el-input v-model="formData.mark" placeholder="请输入唛头或选择唛头" size="large"></el-input>
							</div>
							<div class="mark-select-btn">选择唛头</div> -->
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">物品名称</label>
						<div class="form-input-wrap">
							<el-input v-model="name" placeholder="请输入物品名称" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">备注</label>
						<div class="form-input-wrap">
							<el-input v-model="remark" placeholder="请输入备注" size="large"></el-input>
						</div>
					</div>
				</div>
				<div class="form-col-right">
					<div class="form-item">
						<label class="form-label">物品品类</label>
						<div class="form-input-wrap">
							<el-select v-model="itemCategory" multiple placeholder="请选择（可多选）" class="form-select">
								<el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">小件数量</label>
						<div class="form-input-wrap">
							<el-input v-model="pieceNum" placeholder="请输入小件数量" size="large"></el-input>
						</div>
					</div>
				</div>
			</div>

			<!-- 底部按钮 -->
			<div class="form-actions">
				<div class="action-btn btn-add" @click="addBatch">添加</div>
			</div>
		</div>
	</div>
</template>

<script>
import { packagebatchForecast,warehouselist, countrylist, packageGoodsTypeList,memberMarklist } from "/src/api/api.js"
// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
const CN_FIRST_LETTER = {
	'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
	'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
	'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
	'布': 'B',
	'赤': 'C',
	'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
	'俄': 'E', '厄': 'E',
	'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
	'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
	'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
	'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
	'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
	'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
	'列': 'L', '卢': 'L', '罗': 'L',
	'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
	'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
	'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
	'帕': 'P', '葡': 'P',
	'日': 'R', '瑞': 'R',
	'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
	'索': 'S',
	'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
	'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
	'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
	'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
	'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
	'赞': 'Z', '智': 'Z', '中': 'Z'
}
export default {
	name: 'PackageAddMore',
	data() {
		return {
			name:'',
			pieceNum:'',
			remark:'',
			expressNumbers:'',
			// 选择
			mark: '',
			country: '',
			warehouse: '',
			itemCategory: '',
			warehouseOptions: [],
			countryOptions: [],
			categoryOptions: [],
			maitouOptions:[],
			// 国家选择面板
			countryArr: [],
			searchKeyword: '',
			showCountryPanel: false,
			activeLetter: '',
		}
	},
	computed: {
		// 当前选中国家名称
		selectedCountryName() {
			const item = this.countryArr.find(c => c.value === this.country)
			return item ? (item.label || item.name) : ''
		},
		// 按首字母分组 + 搜索过滤后的列表
		filteredCountries() {
			const kw = this.searchKeyword.trim().toLowerCase()
			let list = this.countryArr
			if (kw) {
				list = list.filter(item => String(item.label || item.name || '').toLowerCase().indexOf(kw) > -1)
			}
			return this.groupByLetter(list)
		},
		// 字母索引条：基于全部国家（不随搜索变化）
		availableLetters() {
			const set = []
			this.countryArr.forEach(item => {
				const l = this.getFirstLetter(item.label || item.name)
				if (set.indexOf(l) === -1) set.push(l)
			})
			return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
		}
	},
	mounted() {
		this.getmemberMarklist()
		this.loadWarehouses()
		this.loadCountries()
		this.loadCategories()
		document.addEventListener('click', this.handleDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick)
	},
	methods: {
		async getmemberMarklist() {
			const res = await memberMarklist({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.memberMarks
					item.value = item.id
				})
				this.maitouOptions = res.rows
			} else {
				this.Tips(res.msg || '唛头加载失败', 'error')
			}
		},
		async loadWarehouses() {
			const res = await warehouselist({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.warehouseOptions = res.rows
			} else {
				this.Tips(res.msg || '仓库加载失败', 'error')
			}
		},
		async loadCountries() {
			const res = await countrylist({})
			if (res.code == 200) {
				var countryArr = []
				;(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
					countryArr.push(item)
				})
				this.countryOptions = res.rows
				this.countryArr = countryArr
			} else {
				this.Tips(res.msg || '国家加载失败', 'error')
			}
		},
		// ===== 国家选择面板相关 =====
		// 切换面板显示状态
		toggleCountryPanel() {
			this.showCountryPanel = !this.showCountryPanel
			if (this.showCountryPanel) {
				this.searchKeyword = ''
				this.activeLetter = ''
			}
		},
		// 选中国家
		selectCountry(item) {
			this.country = item.value
			this.showCountryPanel = false
			this.searchKeyword = ''
		},
		// 点击字母索引，锚定滚动到对应分组
		scrollToLetter(letter) {
			this.activeLetter = letter
			const listEl = this.$refs.countryList
			if (!listEl) return
			const target = listEl.querySelector(`[data-letter="${letter}"]`)
			if (target) {
				listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		// 列表滚动时高亮当前所在字母
		onCountryListScroll() {
			const listEl = this.$refs.countryList
			if (!listEl) return
			const scrollTop = listEl.scrollTop
			let current = ''
			listEl.querySelectorAll('[data-letter]').forEach(el => {
				if (el.offsetTop <= scrollTop + 1) {
					current = el.getAttribute('data-letter')
				}
			})
			this.activeLetter = current
		},
		// 提取首字母（兼容英文/中文，无法识别归入 #）
		getFirstLetter(name) {
			if (!name) return '#'
			const first = String(name).trim().charAt(0)
			if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
			if (/[\u4e00-\u9fa5]/.test(first)) {
				return CN_FIRST_LETTER[first] || '#'
			}
			return '#'
		},
		// 按首字母分组
		groupByLetter(list) {
			const groups = {}
			list.forEach(item => {
				const letter = this.getFirstLetter(item.label || item.name)
				if (!groups[letter]) groups[letter] = []
				groups[letter].push(item)
			})
			const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			return letters.map(l => ({ letter: l, items: groups[l] }))
		},
		// 点击面板外部关闭
		handleDocumentClick(e) {
			if (!this.showCountryPanel) return
			const field = this.$el.querySelector('.country-field')
			if (field && !field.contains(e.target)) {
				this.showCountryPanel = false
			}
		},
		async loadCategories() {
			const res = await packageGoodsTypeList({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.categoryOptions = res.rows
			} else {
				this.Tips(res.msg || '品类加载失败', 'error')
			}
		},
		async addBatch() {
			// 添加批量预报
			if(!this.warehouse){
				this.Tips('请选择入库仓库','error');
				return;
			}
			if(!this.country){
				this.Tips('请选择寄住国家','error');
				return;
			}
			if(!this.mark){
				this.Tips('请选择唛头','error');
				return;
			}
			if(!this.expressNumbers){
				this.Tips('请输入快递单号','error')
				return
			}
			if(!this.itemCategory.length){
				this.Tips('请选择商品品类','error')
				return
			}
			var data = {
				countryId:this.country,
				warehouseId:this.warehouse,
				memberMarksId:this.mark,
				goodsType:this.itemCategory,
				expressNumbers:this.expressNumbers,
				name:this.name,
				pieceNum:this.pieceNum,
				remark:this.remark,
			}
			const res = await packagebatchForecast(data)
			if(res.code==200){
				this.Tips(res.msg)
				this.back()
			}else{this.Tips(res.msg,'error')}
		}
	}
}
</script>

<style lang="scss" scoped>
.package-add-more-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

/* ===== 页面顶部条 ===== */
.page-top-bar {
	width: 1596px;
	height: 88px;
	background: #fff;
	border-radius: 12px;
	margin: 24px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 32px;
	box-sizing: border-box;
}
.welcome-text { display: flex; align-items: baseline; }
.wel-gray { font-size: 20px; color: #666; font-weight: 400; }
.wel-blue { font-size: 20px; color: #0096FF; font-weight: 500; margin-left: 4px; }
.top-actions { display: flex; align-items: center; }
.lang-text { font-size: 16px; font-weight: 500; color: #333; }
.action-gap { width: 1px; height: 18px; margin: 0 16px; }
.user-name { font-size: 18px; color: #333; margin-left: 8px; }
.member-no { font-size: 18px; color: #989FAC; margin-left: 8px; }
.cart-badge { margin-left: -6px; margin-bottom: 12px; width: 10px; height: 10px; }

/* ===== 面包屑 ===== */
.breadcrumb-bar {
	width: 1596px;
	margin: 16px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 4px;
	box-sizing: border-box;
}
.bc-left { display: flex; align-items: center; }
.bc-label { font-size: 16px; color: #333; }
.bc-item { font-size: 16px; color: #666; margin: 0 4px; }
.bc-item.bc-active { color: #0096FF; }
.bc-arrow { width: 12px; height: 12px; margin: 0 8px; }
.bc-right { display: flex; align-items: center; cursor: pointer; }
.bc-back-text { font-size: 16px; color: #0096FF; }
.bc-back-icon { width: 12px; height: 12px; margin-left: 6px; }

/* ===== 表单卡片 ===== */
.form-card {
	width: 1596px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 24px 32px 40px;
	box-sizing: border-box;
}

/* ===== 节标题 ===== */
.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 28px;
}
.sec-icon { width: 4px; height: 16px; margin-right: 12px; }
.sec-title { font-size: 20px; font-weight: 500; color: #333; margin: 0; }

/* ===== 表单行：两列 ===== */
.form-row {
	display: flex;
}
.form-col-left {
	width: 600px;
	flex-shrink: 0;
	margin-right: 44px;
}
.form-col-right {
	width: 600px;
	flex-shrink: 0;
}
.form-item {
	margin-bottom: 28px;
}
.form-label {
	display: block;
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 10px;
}
.form-label--bold {
	font-weight: 500;
}
.form-input-wrap {
	width: 600px;
}
::v-deep .el-select{
		width: 100%;
	}
.form-input-wrap--short {
	width: 466px;
	margin-right: 16px;
}
.form-input-wrap ::v-deep .el-input__inner,
.form-select ::v-deep .el-input__inner {
	height: 50px;
	line-height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
	padding-left: 16px;
}
.form-input-wrap ::v-deep .el-input__inner::placeholder {
	color: #C6C6C6;
}

/* 批量输入提示 */
.form-hint {
	display: block;
	font-size: 14px;
	color: #999;
	margin-bottom: 12px;
	margin-top: -4px;
}

/* 文本框 */
.form-textarea {
	width: 1244px;
}
.form-textarea ::v-deep .el-textarea__inner {
	width: 100%;
	min-height: 200px;
	background: #FAFAFA;
	border: 1px solid #D9D9D9;
	border-radius: 12px;
	font-size: 16px;
	color: #333;
	padding: 20px;
	line-height: 1.6;
	resize: vertical;
}
.form-textarea ::v-deep .el-textarea__inner::placeholder {
	color: #999;
}

/* 唛头行 */
.form-col-inner {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	width: 100%;
}
.form-col-inner .form-label {
	width: 100%;
	margin-bottom: 10px;
}

.mark-select-btn {
	width: 118px;
	height: 50px;
	border: 1px solid #0096FF;
	border-radius: 4px;
	text-align: center;
	line-height: 50px;
	font-size: 16px;
	font-weight: 500;
	color: #0096FF;
	cursor: pointer;
	flex-shrink: 0;
	box-sizing: border-box;
}

/* 占位 */
.form-item--spacer {
	height: 84px;
	visibility: hidden;
}

/* ===== 底部按钮 ===== */
.form-actions {
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
}
.action-btn {
	width: 184px;
	height: 60px;
	border-radius: 10px;
	text-align: center;
	line-height: 60px;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.3s;
}
.btn-add {
	background: #0096FF;
	color: #fff;
}
.btn-add:hover {
	background: #33ABFF;
}

/* ===== 国家选择面板（搜索 + 字母索引） ===== */
.country-field {
	position: relative;
}
.country-trigger {
	width: 100%;
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	box-sizing: border-box;
	cursor: pointer;
	font-size: 16px;
	color: #333;
	.country-trigger-placeholder {
		color: #C6C6C6;
	}
	.country-trigger-arrow {
		color: #999;
		font-size: 12px;
		transition: transform 0.3s;
		&.arrow-up {
			transform: rotate(180deg);
		}
	}
}
.country-panel {
	position: absolute;
	top: calc(100% + 6px);
	left: 0;
	width: 640px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
	z-index: 999;
	padding: 12px;
	box-sizing: border-box;
}
.country-search {
	margin-bottom: 12px;
	::v-deep .el-input__inner {
		height: 40px;
		border: 1px solid #E2E6E9;
		border-radius: 4px;
		padding-left: 30px;
		font-size: 14px;
		color: #333;
	}
	::v-deep .el-input__inner:focus {
		border-color: #0096FF;
	}
	::v-deep .el-input__prefix {
		left: 8px;
		line-height: 40px;
		color: #92969F;
	}
}
.country-body {
	display: flex;
	align-items: flex-start;
}
.country-list {
	flex: 1;
	height: 320px;
	overflow-y: auto;
	padding-right: 8px;
	position: relative;
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 2px;
	}
}
.country-group-title {
	font-size: 13px;
	font-weight: 600;
	color: #0096FF;
	padding: 6px 10px;
}
.country-item {
	padding: 8px 10px;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	border-radius: 4px;
	transition: background 0.2s, color 0.2s;
	&:hover {
		background: #F0F7FD;
		color: #0096FF;
	}
	&.active {
		background: #F0F7FD;
		color: #0096FF;
		font-weight: 500;
	}
}
.country-empty {
	text-align: center;
	color: #BFC6CE;
	font-size: 14px;
	padding: 40px 0;
}
.country-index {
	width: 36px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 320px;
	overflow-y: auto;
	border-left: 1px solid #F0F0F0;
}
.country-index-item {
	font-size: 12px;
	color: #666;
	cursor: pointer;
	line-height: 1.4;
	padding: 1px 0;
	transition: color 0.2s;
	&:hover,
	&.active {
		color: #0096FF;
		font-weight: 600;
	}
}
</style>
